import { lazy, Suspense } from "react";
import { Navigate, useRoutes } from "react-router-dom";
import Loader from "../components/Loader";
import AuthGuard from "../guards/AuthGuard";
import GuestGuard from "../guards/GuestGuard";
import AdminLayout from "../pages/admin/Layout/AdminLayout";
import SuperAdminGuard from "../guards/SuperAdminGuard";

const Loadable = (Component) => (props) => {
  return (
    <Suspense fallback={<Loader />}>
      <Component {...props} />
    </Suspense>
  );
};

export default function Router() {
  return useRoutes([
    // {
    //   path: "/app/about-us",
    //   element: (
    //     <GuestGuard>
    //       <AboutUs />
    //     </GuestGuard>
    //   ),
    // },
    // {
    //   path: "/app/contact-us",
    //   element: (
    //     <GuestGuard>
    //       <ContactUs />
    //     </GuestGuard>
    //   ),
    // },
    // {
    //   path: "/",
    //   element: (
    //     <GuestGuard>
    //       <WebsiteLayout />
    //     </GuestGuard>
    //   ),
    //   children: [
    //     {
    //       path: "/",
    //       element: (
    //         <GuestGuard>
    //           <LandingPage />
    //         </GuestGuard>
    //       ),
    //     },

    //   ],
    // },
    {
      path: "/login",
      element: (
        <GuestGuard>
          <Login />
        </GuestGuard>
      ),
    },
    {
      path: "/",
      element: (
        <AuthGuard>
          <AdminLayout />
        </AuthGuard>
      ),
      children: [
        {
          path: "/",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="dashboard">
                <Dashboard />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/users",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="users">
                <Users />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/add-user",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="users">
                <AddUser />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/edit-user",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="users">
                <EditUser />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/live-drivers",
          element: (
            <AuthGuard>
              <AuthGuard requiredPermission="users">
                <OnlineDriversMap />
              </AuthGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/pricing",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="pricing">
                <Pricing />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/add-pricing",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="pricing">
                <AddPricing />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/edit-pricing",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="pricing">
                <EditPricing />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/promotions",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="pricing">
                <Promotions />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/add-promotion",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="pricing">
                <AddPromotion />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/edit-promotion",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="pricing">
                <EditPromotion />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/banners",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="pricing">
                <Banners />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/add-banner",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="pricing">
                <AddBanner />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/edit-banner",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="pricing">
                <EditBanner />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/longdrive-pricing",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="pricing">
                <LongDrivePricing />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/add-longdrive-pricing",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="pricing">
                <AddLongDrivePricing />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/edit-longdrive-pricing",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="pricing">
                <EditLongDrivePricing />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/admins",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="admin">
                <Admin />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/add-admin",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="admin">
                <AddAdmin />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/edit-admin",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="admin">
                <EditAdmin />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/rides",
          element: (
            <AuthGuard>
              <AuthGuard requiredPermission="rides">
                <Rides />
              </AuthGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/add-ride",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="rides">
                <AddRide />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/edit-ride",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="rides">
                <EditRide />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/complaints",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="complaints">
                <Complaints />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/edit-complaint",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="complaints">
                <EditComplaint />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/long-rides",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="long-drive">
                <LongDrive />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/add-long-ride",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="long-drive">
                <AddLongDrive />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/edit-long-ride",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="long-drive">
                <EditLongDrive />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/wallet-management",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="wallet">
                <WalletManagement />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/process-withdrawal",
          element: (
            <AuthGuard>
              <SuperAdminGuard requiredPermission="wallet">
                <ProcessWithdrawal />
              </SuperAdminGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/vehicles",
          element: (
            <AuthGuard>
              <AuthGuard requiredPermission="vehicles">
                <Vehicles />
              </AuthGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/notifications",
          element: (
            <AuthGuard>
              <AuthGuard requiredPermission="notifications">
                <Notifications />
              </AuthGuard>
            </AuthGuard>
          ),
        },
        {
          path: "/settings",
          element: (
            <AuthGuard>
              <AuthGuard requiredPermission="settings">
                <Settings />
              </AuthGuard>
            </AuthGuard>
          ),
        },
      ],
    },
    {
      path: "*",
      children: [
        { path: "404", element: <NotFound /> },
        { path: "*", element: <Navigate to="/404" replace /> },
      ],
    },
  ]);
}

const NotFound = Loadable(lazy(() => import("../pages/404/Page404")));

//====================ADMIN===================
const Login = Loadable(lazy(() => import("../pages/admin/LoginForms/Login")));

const Dashboard = Loadable(
  lazy(() => import("../pages/admin/Dashboard/Dashboard"))
);
const Users = Loadable(lazy(() => import("../pages/admin/User/Users")));
const AddUser = Loadable(lazy(() => import("../pages/admin/User/AddUser")));
const EditUser = Loadable(lazy(() => import("../pages/admin/User/EditUser")));
const Pricing = Loadable(lazy(() => import("../pages/admin/Pricing/Pricing")));
const AddPricing = Loadable(
  lazy(() => import("../pages/admin/Pricing/AddPricing"))
);
const EditPricing = Loadable(
  lazy(() => import("../pages/admin/Pricing/EditPricing"))
);
const Promotions = Loadable(
  lazy(() => import("../pages/admin/Promotions/Promotions"))
);
const AddPromotion = Loadable(
  lazy(() => import("../pages/admin/Promotions/AddPromotion"))
);
const EditPromotion = Loadable(
  lazy(() => import("../pages/admin/Promotions/EditPromotion"))
);
const Banners = Loadable(
  lazy(() => import("../pages/admin/Banners/Banners"))
);
const AddBanner = Loadable(
  lazy(() => import("../pages/admin/Banners/AddBanner"))
);
const EditBanner = Loadable(
  lazy(() => import("../pages/admin/Banners/EditBanner"))
);
const LongDrivePricing = Loadable(
  lazy(() => import("../pages/admin/Pricing/LongDrivePricing"))
);
const AddLongDrivePricing = Loadable(
  lazy(() => import("../pages/admin/Pricing/AddLongDrivePricing"))
);
const EditLongDrivePricing = Loadable(
  lazy(() => import("../pages/admin/Pricing/EditLongDrivePricing"))
);
const Admin = Loadable(
  lazy(() => import("../pages/admin/AdminList/AdminList"))
);
const AddAdmin = Loadable(
  lazy(() => import("../pages/admin/AdminList/AddAdminList"))
);
const EditAdmin = Loadable(
  lazy(() => import("../pages/admin/AdminList/EditAdminList"))
);
const Rides = Loadable(lazy(() => import("../pages/admin/Ride/Rides")));
const AddRide = Loadable(lazy(() => import("../pages/admin/Ride/AddRide")));
const EditRide = Loadable(lazy(() => import("../pages/admin/Ride/EditRide")));
const Complaints = Loadable(
  lazy(() => import("../pages/admin/Complaints/Complaints"))
);
const EditComplaint = Loadable(
  lazy(() => import("../pages/admin/Complaints/EditComplaint"))
);
const LongDrive = Loadable(
  lazy(() => import("../pages/admin/LongDrive/LongDriveBookings"))
);
const AddLongDrive = Loadable(
  lazy(() => import("../pages/admin/LongDrive/AddLongDriveBooking"))
);
const EditLongDrive = Loadable(
  lazy(() => import("../pages/admin/LongDrive/EditLongDriveBooking"))
);
const WalletManagement = Loadable(
  lazy(() => import("../pages/admin/Wallet/WalletManagement"))
);
const ProcessWithdrawal = Loadable(
  lazy(() => import("../pages/admin/Wallet/ProcessWithdrawal"))
);
const Vehicles = Loadable(
  lazy(() => import("../pages/admin/Vehicles/Vehicles"))
);
const Notifications = Loadable(
  lazy(() => import("../pages/admin/Notifications/Notifications"))
);
const Settings = Loadable(
  lazy(() => import("../pages/admin/Settings/Settings"))
);
const OnlineDriversMap = Loadable(
  lazy(() => import("../components/OnlineDriversMap"))
);
